'use client';

import { useEffect } from 'react';

export const PopupAd: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'aclib';
    script.src = '//acscdn.com/script/aclib.js';
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      if (typeof window !== 'undefined' && window.aclib?.runPop) {
        window.aclib.runPop({
          zoneId: '9984202',
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};
